var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxGreenDone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 1,
  y: 1,
  fill: "#144216",
  stroke: "#32A538",
  strokeWidth: 2,
  className: "raw",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m8.14 14.007 8.82-8.84 1.18 1.18-10 10-4.64-4.64 1.16-1.18z",
  clipRule: "evenodd"
})));
export default SvgCheckboxGreenDone;